import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async logout ({ commit, dispatch }) {
    try {
      await directus.logout()
      commit('setAttr', {
        name: 'token',
        value: undefined
      })
      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
